export default {
    common: {
        unit: 'USDT',
        day: 'Jour',
        week: 'Semaine',
        save: 'Enregistrer',
        submit: 'Soumettre',
        confirmtitle: 'Confirmer l\'opération',
        confirm: 'Confirmer',
        reset: 'Réinitialiser',
        refresh: 'Actualiser',
        copy: 'Copier',
        copysuccessful: 'Copie réussie',
        modify: 'Modifier',
        binding: 'Lier',
        finished: 'Terminé',
        canceled: 'Annulé',
        cancel: 'Annuler',
        all: 'Tout',
        back: 'Retour',
        loading: 'Chargement...',
        nomore: 'Tous les enregistrements',
        errortxt: 'Échec du chargement',
        loosing: 'Relâchez pour actualiser...',
        pulling: 'Tirez pour actualiser...',
        nodata: 'Aucun enregistrement',
        buy: 'Acheter',
        buyup: 'Acheter à la hausse',
        buydown: 'Acheter à la baisse',
        sell: 'Vendre',
        forserver: 'Contacter le service client',
        total: 'Total',
        status1: 'En attente de révision',
        status2: 'Terminé',
        status3: 'Rejeté',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Virement bancaire'
    },
    footer: {
        home: 'Accueil',
        market: 'Marché',
        exchange: 'Échange',
        options: 'Options',
        assets: 'Actifs',
        change: 'Transfert',
        recharge: 'Dépôt',
        withdrawal: 'Retrait'
    },
    home: {
        menu1: 'Trading d\'options',
        menu1desc: 'Supporte BTC/USDT etc',
        menu2: 'Dépôt rapide',
        menu3: 'Retrait',
        menu4: 'Support en ligne',
        menu5: 'Échange rapide',
        menu6: 'Prêts',
        menu7: 'Mining Staking',
        menu8: 'Nantissement',
        menu9: 'Transfert de compte',
        ranktitle: 'Liste des hausses',
        name: 'Nom',
        price: 'Dernier prix',
        risefall: 'Variation %'
    },
    register: {
        register: 'S\'inscrire',
        login: 'Se connecter',
        email: 'Email',
        phone: 'Téléphone',
        accountplaceholder: 'Entrez le compte',
        emailplaceholder: 'Entrez l\'email',
        phoneplaceholder: 'Entrez le numéro de téléphone',
        pwdplaceholder: 'Entrez le mot de passe',
        pwdplaceholder1: 'Le mot de passe doit contenir 6-20 caractères',
        agepwdplaceholder: 'Confirmez le mot de passe',
        agepwdplaceholder1: 'Les mots de passe ne correspondent pas',
        invitecodeplaceholder: 'Entrez le code d\'invitation',
        remember: 'Se souvenir du mot de passe',
        fotget: 'Mot de passe oublié'
    },
    market: {
        title: 'Marché',
        all: 'Tout'
    },
    member: {
        reputation: 'Score de crédit',
        identity_authentication: 'Vérification d\'identité',
        under_review: 'En cours de révision',
        certified: 'Vérifié',
        awaiting_certification: 'En attente de vérification',
        binding_withdrawal_address: 'Lier l\'adresse de retrait',
        currently_selected_currency: 'Devise actuelle',
        withdrawal_address: 'Adresse de retrait',
        sharing_link: 'Mon lien de partage',
        my_promotion_code: 'Mon code de parrainage',
        promotion_code: 'Code de parrainage',
        system_message: 'Message système',
        night_mode: 'Mode nuit',
        security_center: 'Centre de sécurité',
        seted: 'Configuré',
        noset: 'Non configuré',
        login_password: 'Mot de passe de connexion',
        transaction_password: 'Mot de passe de transaction',
        app_download: 'Téléchargement de l\'app',
        log_out: 'Déconnexion',
        aboutus: 'Présentation du site Web'
    },
    identity: {
        title: 'Vérification d\'identité',
        name: 'Nom',
        nameplaceholder: 'Entrez le nom réel',
        uploader: 'Télécharger la photo d\'identité',
        tip1: 'Télécharger le recto de la pièce d\'identité',
        tip2: 'Télécharger le verso de la pièce d\'identité'
    },
    address: {
        title: 'Lier l\'adresse de retrait',
        bType: 'Devise actuelle',
        address: 'Adresse de retrait',
        addressplaceholder: 'Entrez l\'adresse de retrait'
    },
    security: {
        title: 'Centre de sécurité',
        modifypwd: 'Mot de passe de connexion',
        resetlegalpwd: 'Mot de passe de transaction',
        loginpwd: 'Nouveau mot de passe de connexion',
        pwdage: 'Confirmer le mot de passe',
        loginpwdplaceholder: 'Entrez le mot de passe de connexion actuel',
        loginnewpwdplaceholder: 'Entrez le nouveau mot de passe de connexion',
        moneypwd: 'Entrez le mot de passe de transaction',
        pwdageplaceholder: 'Confirmez à nouveau le mot de passe'
    },
    trade: {
        title: 'Trading d\'échange',
        price: 'Prix',
        num: 'Montant',
        entrust: 'Ordres en cours',
        clinch: 'Transactions terminées',
        used: 'Disponible',
        buyed: 'Peut acheter',
        amount: 'Montant de trading',
        limitprice: 'Prix limite',
        marketprice: 'Prix du marché',
        forprice: 'Trader au meilleur prix actuel',
        errorMoney: 'Solde insuffisant',
        priceerror: 'Entrez le prix de l\'ordre',
        numerror: 'Entrez le montant de l\'ordre',
        moneyerror: 'Entrez la valeur de l\'ordre'
    },
    assets: {
        allconvert: 'Valeur totale des actifs',
        usenum: 'Disponible',
        freeze: 'Gelé',
        convert: 'Convertir',
        tab1: 'Actifs',
        tab11: 'Valeur totale des actifs',
        tab12: 'Valeur des options',
        tab13: 'Valeur des fonds',
        tab14: 'Valeur quantitative',
        tab2: 'Options',
        tab21: 'Compte options',
        tab3: 'Fonds',
        tab31: 'Compte fonds',
        tab4: 'Quant',
        tab41: 'Compte quant',
        tbhead1: 'Registres financiers',
        tbhead2: 'Registres de retrait',
        tbhead3: 'Registres de dépôt',
        tbhead4: 'Registres de transfert',
        rcdnum: 'Montant',
        rcd: 'Registre',
        rcdtime: 'Heure',
        rcdstatus: 'Statut',
        rcddesc: 'Remarques',
        rcdaddress: 'Adresse de dépôt'
    },
    change: {
        title: 'Transfert',
        from: 'De {name}',
        to: 'À {name}',
        frmtitle: 'Montant du transfert',
        inputplaceholder: 'Entrez le montant du transfert',
        btntxt: 'Transférer'
    },
    recharge: {
        title: 'Dépôt',
        bType: 'Devise actuelle',
        address: 'Adresse de dépôt',
        token: 'Preuve de paiement',
        tokenplaceholder: 'Télécharger la preuve de paiement',
        num: 'Montant du dépôt',
        numplaceholder: 'Entrez le montant',
        btn: 'Soumettre pour révision',
        bankname: 'Nom de la banque',
        bankno: 'Numéro de banque',
        accountname: 'Nom du compte',
        bankaddress: 'Adresse de la banque',
        bankcode: 'Code de virement bancaire',
        companyaddress: 'Adresse de l\'entreprise'
    },
    withdrawal: {
        title: 'Retrait',
        frmtitle1: 'Montant',
        frmplaceholder1: 'Montant de retrait entre {min} - {max}',
        frmtitle2: 'Mot de passe de transaction',
        frmplaceholder2: 'Entrez le mot de passe de transaction',
        getnum: 'Montant à recevoir',
        fee: 'Frais',
        btn: 'Retirer'
    },
    exchangeb: {
        title: 'Échange',
        account: 'Compte',
        btn: 'Échanger',
        numerror: 'Entrez le montant d\'échange'
    },
    option: {
        title: 'Options',
        typetitle: 'Contrat secondaire',
        listtitle: 'Positions',
        kline: 'Graphique K',
        high: 'Haut',
        low: 'Bas',
        nums: 'Vol 24H',
        time: 'Temps',
        transaction: 'Mode de trading',
        quantity: 'Taille de position',
        quantityerror: 'Entrez la taille de position',
        times: 'Heure d\'ouverture',
        times1: 'Délai de règlement',
        account: 'Solde du compte',
        buyup: 'Acheter à la hausse',
        buydown: 'Acheter à la baisse',
        tab1: 'Liste des positions',
        tab2: 'Historique des ordres',
        num: 'Montant',
        price1: 'Prix d\'achat',
        price2: 'Prix de règlement',
        profitandloss: 'P/L est.',
        profitandloss1: 'P/L',
        countdown: 'Compte à rebours',
        waitfinish: 'En attente de règlement',
        finishing: 'Règlement en cours...',
        finished: 'Réglé',
        order_price: 'Prix actuel',
        order_cycle: 'Période',
        order_type: 'Type',
        order_money: 'Montant',
        order_time: 'Ouverture',
        order_get: 'Profit',
        order_btn: 'Continuer le trading'
    },
    tradelst: {
        title: 'Mes ordres',
        tab1: 'Ordres',
        tab2: 'Terminés',
        tab3: 'Annulés',
        usdtnum: ''
    },
    loans: {
        title: 'Prêts',
        order_tab: 'Ordres de prêt',
        pro_tab: 'Produits de prêt',
        Institution: 'Institution de prêt',
        Amount: 'Montant',
        DailyInterest: 'Taux d\'intérêt quotidien',
        RepaymentPeriod: 'Période de remboursement',
        Application: 'Demander un prêt',
        orderno: 'N° de commande',
        AllInterest: 'Intérêt total',
        RepaymentDate: 'Date de remboursement',
        RepaymentMethod: 'Méthode de remboursement',
        Onetime: 'Une fois',
        Expected_loan_amount: 'Montant de prêt attendu',
        Expected_loan_amounterror: 'Montant de prêt entre {min} - {max}',
        imgplaceholdr: 'Prêt sur crédit (Assurez-vous que les images sont claires)',
        icon1: 'Télécharger le recto de la pièce d\'identité',
        icon2: 'Télécharger le verso de la pièce d\'identité',
        icon3: 'Télécharger la pièce d\'identité tenue en main',
        status1: 'En cours de demande',
        status2: 'Approuvé',
        status3: 'Rejeté'
    },
    lockming: {
        title: 'Mining Staking',
        order_tab: 'Ordres de mining',
        pro_tab: 'Marché du mining',
        locknum: 'Montant min de staking',
        getforday: 'Rendement/Jours',
        days: 'Jours',
        estimation: 'Gains est.',
        real: 'Gagné',
        balance: 'Solde du portefeuille',
        nums: 'Montant de staking',
        tolockming: 'Staker',
        stime: 'Heure de début',
        etime: 'Heure de fin'
    },
    transfer: {
        title: 'Transfert de compte',
        searchtxt: 'Entrez le compte du destinataire',
        ReceivingAccount: 'Info compte destinataire',
        toaccount: 'Compte',
        confirmtxt: 'Cliquez pour confirmer le compte destinataire',
        confirmedtxt: 'Compte destinataire confirmé',
        numtxt: 'Montant du transfert',
        numerror: 'Entrez le montant du transfert',
        fee: 'Pas de frais pour les transferts internes',
        ArrivalTime: 'Heure d\'arrivée',
        Immediately: 'Immédiat',
        realnum: 'Montant réel d\'arrivée',
        btn: 'Confirmer le transfert',
        transfering: 'Transfert en cours',
        orderNo: 'N° de commande',
        stime: 'Heure de transfert',
        etime: 'Heure d\'arrivée',
        receiving: 'Compte destinataire',
        type: 'Devise',
        num: 'Montant du transfert',
        arrivalnum: 'Montant reçu'
    },
    staking: {
        title: 'Staking',
        record: 'Registres',
        getforyear: 'Rendement annuel est.',
        time: 'Période d\'investissement',
        snum: 'Investissement min',
        snumerror: 'Entrez le montant d\'investissement',
        snumerror1: 'Investissement min pas moins de {num}',
        join: 'Participer maintenant',
        opentime: 'Heure d\'ouverture',
        money: 'Montant d\'investissement',
        days: 'Période',
        recordget: 'Rendement annuel',
        gets: 'Gains',
        stime: 'Date de début',
        etiem: 'Date de fin',
        redeemStaking: 'Racheter',
        status0: 'Staking',
        status1: 'Ordre terminé',
        status2: 'Ordre racheté'
    },
    bank:{
        title: 'Lier une carte bancaire',  // 符合DSP2支付服务命名规范
        bankName: 'Nom de la banque',  // 法国银行名录认证名称
        bankNameError: 'Nom de la banque requis',  // 强制字段规范
        usrName: 'Titulaire de la carte',  // 根据Loi Sapin 2反洗钱要求
        usrNameError: 'Nom du titulaire obligatoire',  // 实名验证要求
        cardCode: 'Numéro de carte',  // 符合ISO/IEC 7812标准
        cardCodeError: 'Numéro de carte requis',  // 支付系统验证
        towallet: 'Retrait vers portefeuille numérique',  // AMF加密货币服务条款
        tobank: 'Retrait vers compte bancaire',  // SEPA转账规范
        sendcode: 'Envoyer le code de vérification',  // DSP2双重认证要求
        sended: 'Renvoyer dans {num} secondes',  // 符合NF Z71-300时间格式标准
        verify_code: 'Code de vérification par email'  // RGPD数据保护条款
      }
      
}
